export const cinemasList = [
  { content: 'Katowice' },
  { content: 'Kraków' },
  { content: 'Łódź' },
  { content: 'Poznań' },
  { content: 'Sopot' },
  { content: 'Warszawa' },
  { content: 'Wrocław' },
  { content: 'Zgorzelec' },
];
